<ng-container *transloco="let t">
  <app-page-template [displayLargeMobileFooter]="false" [showPageHeader]="!isMobile">
    <form [formGroup]="inputForm">
      @if (hasProfile) {
      <app-my-tracey-page-header
            [backgroundColor]="isMobile ? 'var(--grey-1000)' : 'white'" [color]="isMobile ? 'white' : 'var(--slate-800)'"
            [key]="'app.user.my.tracy.back'"
            (onBackCallback)="toProfilePage()"></app-my-tracey-page-header>
      }
    <div class="container">
    <ng-container>
        <div class="pb-300-100 pt-3">
          @if (!hasProfile) {
            <ng-container *ngTemplateOutlet="myTraceyWarning"></ng-container>
          }
          <div>
              <!--                LG view-->
              <div class="row d-none d-xl-flex pt-2">
                <div class="col-md-custom-30">
                  <div class="h-100 profile-section">
                    <div class="justify-content-center align-items-center">
                      <ng-container *ngTemplateOutlet="avatar"></ng-container>
                    </div>
                      <ng-container *ngTemplateOutlet="name"></ng-container>
                  </div>
                </div>

                <div class="col-md-custom-70">
                  <div class="d-flex fw-500 fs-20 mb-3 ps-1">
                    <div style="width: 5px; height: auto; background-color: #b05963; border-radius: 8px;" class="me-3"></div>
                    <p> {{ t('app.user.profile.basic.data') }} </p>
                  </div>
                  <div class="profile-section">
                      <ng-container *ngTemplateOutlet="basicInformation"></ng-container>
                  </div>
                </div>

                <div class="col-md-12 pt-32">
                  <div class="d-flex fw-500 fs-20 mb-3 ps-1">
                    <div style="width: 5px; height: auto; background-color: #b05963; border-radius: 8px;" class="me-3"></div>
                    <p> {{ t('app.user.profile.other.information') }} </p>
                  </div>

                  <div class="profile-section">
                      <ng-container *ngTemplateOutlet="otherInformation"></ng-container>
                  </div>
                </div>
                <div class="d-flex justify-content-end align-items-center pt-32">
                  <app-button-alt [text]="t('app.user.profile.update')" (onClickCallback)="saveAll()"></app-button-alt>
                </div>
              </div>

              <!--                Mobile view-->
              <div class="d-flex d-xl-none flex-column justify-content-center align-items-center w-100">
                <div class="avatar-mobile-wrapper p-3 mt-4 mb-2 w-100 profile-section">
                  <ng-container *ngTemplateOutlet="avatar"></ng-container>
                </div>

                <app-nav-tabs [reduceHorizontalSpacing]=true class="w-100">
                  <app-nav-tab [title]="t('app.user.profile.personal.information')" [itemId]="1">
                    <ng-template>
                      <div class="profile-section">
                        <div class="pb-2">
                          <ng-container *ngTemplateOutlet="name"></ng-container>
                        </div>
                        <ng-container
                                *ngTemplateOutlet="basicInformation">
                        </ng-container>
                      </div>
                      <div class="d-flex justify-content-end align-items-center pt-32">
                        <app-button-alt [text]="t('app.user.profile.update')" (onClickCallback)="savePersonalInfo()"></app-button-alt>
                      </div>
                    </ng-template>
                  </app-nav-tab>
                  <app-nav-tab [title]="t('app.user.profile.other.information')" [itemId]="2">
                    <ng-template>
                      <div class="profile-section">
                        <ng-container
                                *ngTemplateOutlet="otherInformation">

                        </ng-container>
                      </div>
                      <div class="d-flex justify-content-end align-items-center pt-32">
                        <app-button-alt [text]="t('app.user.profile.update')" (onClickCallback)="saveOtherInfo()"></app-button-alt>
                      </div>
                    </ng-template>
                  </app-nav-tab>
                </app-nav-tabs>
              </div>
          </div>
        </div>
  </ng-container>

  <ng-template #name>
    <div>
      <div class="row">
        <div class="col-12 pt-3">
          <app-input formControlName="firstname" label="app.common.first.name"/>
        </div>
      </div>
      <div class="row">
        <div class="col-12 pt-3">
          <app-input formControlName="lastname" label="app.common.last.name"/>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #basicInformation>
    <div>
      <div class="row">
        <div class="col-12 col-xl-6">
          <app-select formControlName="gender" [items]="genders" [labelKey]="'id'" labelKeyPrefix="app.common.gender."
                      label="app.common.gender" valueKey="id"/>
        </div>
        <div class="col-12 col-xl-6">
            <div class="form-floating">
              <app-date-time-input formControlName="birthDay" [displayTime]="false" [openDate]="calendarNavigationDate"
                                   [displaySeconds]="false" [displayMilliseconds]="false"
                                   [minDate]="birthdayMinDate" [maxDate]="currentDate"
                                   [label]="t('app.common.birthDay')"/>
            </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-xl-6">
          <div class="pt-3">
            <app-input formControlName="email" label="app.common.email"/>
          </div>
        </div>
        <div class="col-12 col-xl-6">
          <div class="pt-3">
            <app-tel-input [formControlName]="'phoneNumber'" [label]="t('app.common.phoneNumber')"
                           [numberPlaceholder]="t('app.common.phoneNumber')"></app-tel-input>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-xl-6">
          <div class="pt-3">
            <app-input formControlName="address" label="app.common.address"/>
          </div>
        </div>
        <div class="col-12 col-xl-6">
          <div class="pt-3">
            <app-input formControlName="zip" label="app.common.zip"/>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-xl-6">
          <div class="pt-3">
            <app-input formControlName="city" label="app.common.placeOfResidence"/>
          </div>
        </div>
        <div class="col-12 col-xl-6">
          <div class="pt-3">
            <app-select formControlName="country" [hasDefault]="true" [items]="countries" valueKey="id"
                        labelKey="id" labelKeyPrefix="app.common.country."
                        label="app.common.country"/>
          </div>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #otherInformation>
    <div>
      <div class="row">
        <div class="col-12 col-xl-6">
          <div class="pt-3">
            <app-input formControlName="club" label="app.common.club"/>
          </div>
        </div>
        <div class="col-12 col-xl-6">
          <div class="pt-3">
            <app-input formControlName="nickname" label="app.common.nickname"/>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-xl-6">
          <div class="pt-3">
            <app-tel-input [formControlName]="'emergencyPhone'" [label]="t('app.common.emergencyPhone')"
                           [numberPlaceholder]="t('app.common.emergencyPhone')"></app-tel-input>
          </div>
        </div>
        <div class="col-12 col-xl-6">
          <div class="pt-3">
            <app-input formControlName="identityCardNumber" label="app.common.identityCardNumber"/>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-xl-6">
          <div class="pt-3">
            <div class="form-floating">
              <app-date-time-input formControlName="identityCardExpires" [displayTime]="false" [label]="t('app.common.identityCardExpires')"/>
            </div>
          </div>
        </div>
        <div class="col-12 col-xl-6">
          <div class="pt-3">
            <app-input formControlName="identityCardIssuer" label="app.common.identityCardIssuer"/>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-xl-6">
          <div class="pt-3">
            <app-select formControlName="tshirtSize" [hasDefault]="true" [items]="tshirtSizes" labelKey="name"
                        valueKey="alternativeId" label="app.common.tshirtSize"/>
          </div>
        </div>
        <div class="col-12 col-xl-6">
          <div class="pt-3">
            <app-select formControlName="meal" [hasDefault]="true" [items]="meals" labelKey="alternativeId"  labelKeyPrefix="app.common.meal."
                        valueKey="alternativeId"
                        label="app.common.meal"/>
          </div>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #avatar>
    <div class="d-flex flex-column justify-content-center align-items-center">
      <div class="avatar-wrapper pt-0 py-xl-3">
        <div class="el-1">
          <div>
            <input type="file" accept="image/*" #file (change)="processFile(file)">
            @if (profilePicture) {
              <button class="avatar-button" (click)="file.click()">
                <img [src]="profilePicture" class="avatar" alt="Avatar">
              </button>
            } @else {
              <button class="avatar-button" (click)="file.click()">
                <img src="assets/img/blank_profile.webp" class="avatar" alt="Avatar">
              </button>
            }
          </div>
        </div>
        @if (profilePicture && editProfilePictureMode) {
          <div class="el-2">
            <button (click)="onDeleteProfilePicture()" class="btn shadow btn-circle blue-btn">
              <i class="bi bi-x-lg bold"></i>
            </button>
          </div>
        }
        @if (editProfilePictureMode) {
          <div class="el-3">
            <input type="file" accept="image/*" #file (change)="processFile(file)">
            <button (click)="file.click()" class="btn shadow btn-circle black-btn">
              <i class="bi bi-upload bi-bold"></i>
            </button>
          </div>
        } @else {
          <div class="el-3">
            <button type="button" (click)="onEditProfilePicture()"
                    class="btn shadow btn-circle blue-btn d-none d-xl-flex align-items-center justify-content-center">
              <img src="assets/icons/icons-alt/edit.svg" alt="Edit">
            </button>
            <div class="d-flex d-xl-none btn-circle-xs"  (click)="onEditProfilePicture()">
              <img src="assets/icons/icons-alt/edit-avatar-xs.svg" alt="Edit">
            </div>
          </div>
        }
      </div>
    </div>
  </ng-template>


  <ng-template #myTraceyWarning>
    <div class="my-5">
      <ngb-alert [dismissible]="false" type="my-tracey-warning">
        {{t('app.common.myTracey.warning')}}
      </ngb-alert>
    </div>
  </ng-template>

    </div>
    </form>
  </app-page-template>
</ng-container>


